import React from 'react';
import { ColorValueStrict, Hint, HintContent, Icon, IconButton, Typography } from 'fronton-react';

import {
  modalShopItem,
  modalShopItemLabel,
  modalShopItemStock,
  questionIconStyleModal,
  StockContainer,
} from './styles';
import { useTranslation } from 'react-i18next';
import { QuestionIcon } from '@fronton/icons-react';

type ModalShopItemProps = {
  storeName: string;
  stockUnit: string;
  stockValue: number;
  address?: string;
  displaySample?: boolean;
};

export const ModalStoreItem: React.FC<ModalShopItemProps> = ({
  storeName,
  stockValue,
  stockUnit,
  address,
  displaySample,
}) => {
  const { t } = useTranslation();
  let inStockText = t('product-info.stocks.in-stores.not-available-modal');
  let inStockColor: ColorValueStrict = 'secondary-orange-primary';
  const [hintOpen, setHintOpen] = React.useState(false);
  const iconButton = (
    <IconButton
      onMouseEnter={() => setHintOpen(true)}
      onMouseLeave={() => setHintOpen(false)}
      className={questionIconStyleModal}
      aria-label={t('product-info.stocks.in-stores.aria-label-tooltip')}
    >
      <Icon color="secondary-blue-primary" size="space-200">
        <QuestionIcon />
      </Icon>
    </IconButton>
  );
  if (displaySample) {
    inStockText = t('product-info.stocks.in-stores.has-sample-modal');
    inStockColor = 'secondary-blue-primary';
  }
  if (stockValue) {
    inStockText = t('product-info.stocks.in-stores.count-modal', {
      stock: Number(stockValue),
      unit: stockUnit,
    });
    inStockColor = 'success-primary';
  }
  return (
    <div className={modalShopItem}>
      <div className={modalShopItemLabel}>
        <Typography size="body_accent" variant="s" color="text-primary">
          {storeName}
        </Typography>
      </div>
      {address && (
        <Typography data-qa="modal-store-item-address" variant="caption" color="text-secondary">
          {address}
        </Typography>
      )}
      <StockContainer>
        <Typography
          className={modalShopItemStock}
          color={inStockColor}
          variant="caption_accent"
          data-qa="modal-store-item-in-stock-text"
        >
          {inStockText}
        </Typography>
        {displaySample && !stockValue && (
          <Hint anchor={iconButton} placement="bottom-end" open={hintOpen}>
            <HintContent paragraph={t('product-info.stocks.in-stores.tooltip-content')} />
          </Hint>
        )}
      </StockContainer>
    </div>
  );
};
